export const settingsConstants = {
    REQUEST: 'REQUEST_SETTINGS',
    GET: 'GET_SETTINGS',
    SAVE: 'BULK_UPDATE',
    FAIL: 'SETTINGS_FAILURE',
}; 